import { render, staticRenderFns } from "./DeductionForm.vue?vue&type=template&id=2ac25ad4"
import script from "./DeductionForm.vue?vue&type=script&lang=js"
export * from "./DeductionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports